import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { IAllocatedAllotment, IAssignedAllotment, IProduct, IPurchasedAllotment, IResponse } from '@interfaces/index';

@Injectable({
  providedIn: 'root',
})
export class AllotmentService {

  constructor(
    private _http_service: HttpService
  ) { }

  addAllotment(products: IProduct[]): Observable<IResponse<any>> {
    return this._http_service.post('allotments/add-allotment', {
      products: products
    })
  };

  allocate(params: {
    selected_org_id: number,
    assessment_id: number,
    amount: number[]
  }): Observable<IResponse<{}>> {
    return this._http_service.post('allotments/allocate', params)
  }

  unallocate(assessment: IAllocatedAllotment): Observable<IResponse<{}>> {
    return this._http_service.post<IResponse<{}>>('allotments/unallocate', assessment);
  }

  getPurchasedAllotments(): Observable<IResponse<IPurchasedAllotment[]>> {
    return this._http_service.post('allotments/get-purchased', {})
  };

  getAll(): Observable<IResponse<IAssignedAllotment[]>> {
    return this._http_service.post('allotments/get-all', {})
  };
}
